import styled from 'styled-components';
import { colorCSS, shadow, zIndex, mediaMinLg } from '../../../styles';
export const BackButton = styled.button `
  align-items: center;
  background: transparent;
  border: 0;
  color: ${colorCSS('N800')};
  display: flex;
  gap: 0.5rem;
  opacity: 1;
  padding: 1rem;
  transition: opacity 0.3s ease;
  transition-delay: 0.2s;
  &[data-hidden='true'] {
    opacity: 0;
  }
`;
export const Button = styled.a `
  background-color: ${colorCSS('N0')};
  border: 1px solid ${colorCSS('B300')};
  color: ${colorCSS('N800')};
  display: block;
  padding: 1rem;
  text-align: center;
  text-decoration: none;
`;
export const ButtonDark = styled(Button) `
  background-color: ${colorCSS('N800')};
  border-color: ${colorCSS('N800')};
  color: ${colorCSS('N0')} !important;
  &:active {
    background-color: ${colorCSS('N100')};
    border-color: ${colorCSS('N100')};
  }
`;
export const ButtonPrimary = styled(Button) `
  background-color: ${colorCSS('B300')};
  border-color: ${colorCSS('B300')};
  color: ${colorCSS('N0')} !important;
  &:active {
    background-color: ${colorCSS('B500')};
    border-color: ${colorCSS('B500')};
  }
`;
export const Buttons = styled.div `
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
export const Header = styled.header `
  background-color: ${({ startTransparent }) => colorCSS('N0', startTransparent ? 0 : 1)};
  height: 70px;
  overflow: hidden;
  position: fixed;
  top: 0;
  transition: height 0.3s linear, box-shadow 0.3s linear 0.3s,
    background-color 0.3s linear 0.3s;
  width: 100%;
  z-index: ${zIndex.headerShroud};
  &[data-scrolled='true'] {
    background-color: ${colorCSS('N0', 1)};
    box-shadow: ${shadow.normal};
  }
  &[data-open='true'] {
    background-color: ${colorCSS('N0', 1)};
    box-shadow: ${shadow.normal};
    height: 100%;
    transition: height 0.3s linear 0.1s, box-shadow 0.1s linear,
      background-color 0.1s linear;
  }
  ${mediaMinLg(`
    display: none;
  `)}
`;
export const Link = styled.a `
  color: ${colorCSS('N800')} !important;
  text-decoration: none;
`;
export const LogoWrapper = styled.div `
  opacity: 1;
  transition: all 0.3s ease;
  transition-delay: 0.2s;
  &[data-hidden='true'] {
    opacity: 0;
    margin-left: -141.69px;
  }
`;
export const MenuButton = styled.button `
  align-items: center;
  background-color: transparent;
  display: flex;
  border: 0;
  height: 3.5rem;
  justify-content: center;
  margin-left: auto;
  overflow: hidden;
  padding: 0;
  width: 3.5rem;
  &:focus {
    background-color: transparent;
  }
`;
export const NavBar = styled.div `
  align-items: center;
  display: flex;
  height: 70px;
  justify-content: space-between;
  z-index: ${zIndex.header};
  ${mediaMinLg(`
    height: 60px;
  `)}
`;
export const NavLinkContainer = styled.div `
  display: block !important;
  > * {
    padding-left: 0 !important;
  }
`;
export const Page = styled.div `
  background-color: ${colorCSS('N0')};
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  left: 0;
  overflow: auto;
  padding: 0 1rem 1rem;
  position: absolute;
  top: 70px;
  transition: left 0.4s ease;
  width: 100%;
  h2 {
    margin-bottom: 0;
  }
  h2,
  h3 {
    color: ${colorCSS('N800')};
    font-family: 'Charlie Text';
    font-size: 1rem;
    font-weight: 500;
  }
  p:last-child {
    margin-bottom: 0;
  }
  &[data-offscreen='left'] {
    left: -100vw;
  }
  &[data-offscreen='right'] {
    left: 100vw;
  }
`;
export const PageContainer = styled.div `
  opacity: ${({ open }) => (open ? 1 : 0)};
  transition: opacity 0.6s ease;
  transition-delay: 0.1s;
`;
export const Secondary = styled.div `
  padding: 1.5rem;
  background-color: ${colorCSS('P50', 0.4)};
  p {
    color: ${colorCSS('N400')};
    font-size: 0.75rem;
  }
`;
export const Tab = styled.button `
  background: transparent;
  border: 0;
  color: ${colorCSS('N800')};
  display: flex;
  justify-content: space-between;
  padding: 0 0.5rem 0 0;
  width: 100%;
`;
export const TabList = styled.div `
  border-top: 1px solid ${colorCSS('N40')};
  > * {
    align-items: center;
    border-bottom: 1px solid ${colorCSS('N40')};
    display: flex;
    min-height: 70px;
  }
`;
//# sourceMappingURL=SmallNav.styles.js.map